<template>
  <div class="home-page">
    <p class="empty-message">
      No data available
    </p>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.home-page {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 24px;
}

.empty-message {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  color: #6b7280;
  text-align: center;
}
</style>